import { IPersonEmailsData } from 'modules/Analytics/interfaces';

export const serializeContactEmails = (jsonData: any): IPersonEmailsData[] => {
  let newData: IPersonEmailsData[] = [];
  for (let email of jsonData) {
    newData.push({
      id: email?.email_id as number,
      thumbnail: email?.email_thumbnail as string,
      title: email?.email_name as string,
      subject: email?.email_subject as string,
      sentBy: email?.sender_email as string,
      sentDate: email?.sent_date as string,
      campaignName: email?.campaign_name as string,
      campaignId: email?.campaign_id as number,
      workflowName: email?.workflow_name as string,
      workflowId: email?.workflow_id as number,
      status: email?.status as string,
      sentCount: email?.sent_count as number,
      totalOpens: email?.total_opens as number,
      totalClicks: email?.total_clicks as number,
      uniqueOpens: email?.unique_opens as number,
      uniqueClicks: email?.unique_clicks as number,
      score: email?.score as string,
      deliveryRate: email?.delivery_rate as number,
      generationId: email?.generation_id as number,
    });
  }
  return newData;
};
